import { render, staticRenderFns } from "./KategoriDuzenle.vue?vue&type=template&id=a80522fa&scoped=true&"
import script from "./KategoriDuzenle.vue?vue&type=script&lang=js&"
export * from "./KategoriDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./KategoriDuzenle.vue?vue&type=style&index=0&id=a80522fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80522fa",
  null
  
)

export default component.exports